import axios from "axios";

const useDataPrivacy = () => {
  const documentDomain = import.meta.env.VITE_DOMAIN;

  const processHtml = (stringData) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(stringData, "text/html");
    const inputValues = {};
    try {
      inputValues.version = doc.querySelector(
        ".truman-version-details input#truman-version-number"
      ).value;
    } catch (e) {
      inputValues.version = "";
    }
    try {
      inputValues.hash = doc.querySelector(
        ".truman-version-details input#truman-commit-hash"
      ).value;
    } catch (error) {
      inputValues.hash = "";
    }
    try {
      inputValues.dataTime = doc.querySelector(
        ".truman-version-details input#truman-commit-datetime"
      ).value;
    } catch (error) {
      inputValues.dataTime = "";
    }
    return { ...inputValues };
  };
  const getHtml = async (link) => {
    try {
      const res = await axios.get(link, {
        headers: {
          "Content-Type": "text/html",
        },
      });
      return processHtml(res?.data || "");
    } catch (error) {}
  };
  const getDataPrivacy = async ({
    controller_code,
    customer_scope,
    language,
  }) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/ps/data_privacy_fragment`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };

  return { getDataPrivacy };
};

export default useDataPrivacy;
